import { connect } from 'react-redux';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import axios from 'axios'
import Table from 'react-bootstrap/Table';
import { Spinner, Tooltip, OverlayTrigger } from 'react-bootstrap';
import fileDownload from 'js-file-download';
import TextFieldGroup from '../common/TextFieldGroup';

const div1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
  padding: "3px"
}

const div2 = {
  width: "99%",
  height: "80%",
  background: "#fff",
  boxShadow: "15px 15px 25px #ccc",
  borderRadius: "15px"
}

const centerText = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
class adminPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rawData: '',
      name: '',
      email: '',
      who: 'active',
    }
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  addNewIntern(e) {
    e.preventDefault();
    const payload = {
      name: this.state.name,
      email: this.state.email
    }
    console.log(payload)
    axios.post(`/api/adminApi/addNewIntern/`, payload)
      .then(resp => {
        Toast.fire({
          icon: 'success',
          title: 'Uneto'
        })
      })
      .catch(err => {
        Toast.fire({
          icon: 'error',
          title: err.response.data.message
        })
      })
  }

  removeIntern(id, name) {
    const payload = {
      internId: id
    }
    Swal.fire({
      title: 'Da li sigurno želiš da sakriješ ovog korisnika?',
      text: `Sakrij korisnika sa imenom ${name}, moći češ kasnije da pogledaš njegove rezultate`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Odustani',
      confirmButtonText: 'Sakrij'
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          axios.post(`/api/adminApi/hideIntern/`, payload)
            .then(res => {
              Toast.fire({
                icon: 'success',
                title: 'Uspešno sakriveno!'
              })
            })
            .catch(err => {
              Toast.fire({
                icon: 'error',
                title: 'Eeeh neki problem!'
              })
            })
        }
      })
  }

  getResultsAll() {
    const payload = {}
    axios.post(`/api/export/getResults/`, payload, { responseType: 'blob' })
      .then(res => {
        var filename = "Rezultati testa svih kandidata.xlsx";
        fileDownload(res.data, filename);
        Toast.fire({
          icon: 'success',
          title: 'Preuzimanje rezultata'
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getResults(id, name) {
    const payload = {
      _id: id
    }
    axios.post(`/api/export/getResults/`, payload, { responseType: 'blob' })
      .then(res => {
        var filename = "Rezultati testa " + name + ".xlsx";
        fileDownload(res.data, filename);
        Toast.fire({
          icon: 'success',
          title: 'Preuzimanje rezultata'
        })
      })
      .catch(err => {
        console.log(err)
      })
  }
  intI(Id, name) {
    Swal.fire({
      title: 'Da li sigurno želiš da dozvoliš da lider ponovo radi ovaj test?',
      text: `Dozvoli ponovni pristup za nalog ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ne mora da radi opet',
      confirmButtonText: 'Još jedna šansa!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          _id: Id
        }
        axios.post(`/api/intApi/deleteResultForSpecificInternTestI/`, payload)
          .then(response => {
            Toast.fire({
              icon: response.data.sign,
              title: response.data.message
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      else {
        Toast.fire({
          icon: 'info',
          title: 'Izgleda da smo strogi danas :D'
        })
      }
    })
  }
  intII(Id, name) {
    Swal.fire({
      title: 'Da li sigurno želiš da dozvoliš da lider ponovo radi ovaj test?',
      text: `Dozvoli ponovni pristup za nalog ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ne mora da radi opet',
      confirmButtonText: 'Još jedna šansa!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          _id: Id
        }
        axios.post(`/api/intApi/deleteResultForSpecificInternTestII/`, payload)
          .then(response => {
            Toast.fire({
              icon: response.data.sign,
              title: response.data.message
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      else {
        Toast.fire({
          icon: 'info',
          title: 'Izgleda da smo strogi danas :D'
        })
      }
    })

  }
  intIII(Id, name) {
    Swal.fire({
      title: 'Da li sigurno želiš da dozvoliš da lider ponovo radi ovaj test?',
      text: `Dozvoli ponovni pristup za nalog ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ne mora da radi opet',
      confirmButtonText: 'Još jedna šansa!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          _id: Id
        }
        axios.post(`/api/intApi/deleteResultForSpecificInternTestIII/`, payload)
          .then(response => {
            Toast.fire({
              icon: response.data.sign,
              title: response.data.message
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      else {
        Toast.fire({
          icon: 'info',
          title: 'Izgleda da smo strogi danas :D'
        })
      }
    })

  }
  personality(Id, name) {
    Swal.fire({
      title: 'Da li sigurno želiš da dozvoliš da lider ponovo radi ovaj test?',
      text: `Dozvoli ponovni pristup za nalog ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ne mora da radi opet',
      confirmButtonText: 'Još jedna šansa!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          _id: Id
        }
        axios.post(`/api/personalityApi/deleteResultForSpecificIntern/`, payload)
          .then(response => {
            Toast.fire({
              icon: response.data.sign,
              title: response.data.message
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      else {
        Toast.fire({
          icon: 'info',
          title: 'Izgleda da smo strogi danas :D'
        })
      }
    })

  }
  english(Id, name) {
    Swal.fire({
      title: 'Da li sigurno želiš da dozvoliš da lider ponovo radi ovaj test?',
      text: `Dozvoli ponovni pristup za nalog ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ne mora da radi opet',
      confirmButtonText: 'Još jedna šansa!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          _id: Id
        }
        axios.post(`/api/engApi/deleteResultForSpecificIntern/`, payload)
          .then(response => {
            Toast.fire({
              icon: response.data.sign,
              title: response.data.message
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      else {
        Toast.fire({
          icon: 'info',
          title: 'Izgleda da smo strogi danas :D'
        })
      }
    })

  }

  getInternsByStatus(status) {
    const payload = {
      who: status
    }
    axios.post('/api/adminApi/getAllInterns/', payload)
      .then(response => {
        this.setState({ rawData: response.data })
      })
      .catch(err => {
        console.log(err)
      })
  }

  componentDidMount() {
    this.getInternsByStatus('active')
  }

  render() {
    const rawData = this.state.rawData;
    let tableData;
    if (rawData == null) {
      tableData = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>)
    } else {
      if (rawData.length > 1) {
        tableData = rawData.map(intern => (
          <tr key={intern._id}>
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Prebaci na listu sakrivenih, možeš mi pristupiti kasnije.
                </Tooltip>}
              >
                <button className="btn btn-error btn-fill" onClick={this.removeIntern.bind(this, intern._id, intern.name)} />
              </OverlayTrigger>{intern.name}
            </td>
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Preuzmi sve rezultate za korisnika.
                </Tooltip>}
              >
                <button className="btn btn-success btn-fill" onClick={this.getResults.bind(this, intern._id, intern.name)} />
              </OverlayTrigger> {intern.email}
            </td>
            {/*<td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Obriši rezultate testa engleskog i dozvoli da ponovo radi test.
                </Tooltip>}
              >
                <button className="btn btn-info btn-fill" onClick={this.english.bind(this, intern._id, intern.name)} />
              </OverlayTrigger> {intern.accessedEng}
            </td>*/}
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Obriši rezultate testa ličnosti i dozvoli da ponovo radi test.
                </Tooltip>}
              >
                <button className="btn btn-info btn-fill" onClick={this.personality.bind(this, intern._id, intern.name)} />
              </OverlayTrigger> {intern.accessedPer}
            </td>
            {/*<td>{intern.downloadedExcel} </td>*/}
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Obriši rezultate testa sposobnosti 1 i dozvoli da ponovo radi test.
                </Tooltip>}
              >
                <button className="btn btn-info btn-fill" onClick={this.intI.bind(this, intern._id, intern.name)} />
              </OverlayTrigger> {intern.intI}
            </td>
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Obriši rezultate testa sposobnosti 2 i dozvoli da ponovo radi test.
                </Tooltip>}
              >
                <button className="btn btn-info btn-fill" onClick={this.intII.bind(this, intern._id, intern.name)} />
              </OverlayTrigger> {intern.intII}
            </td>
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Obriši rezultate testa sposobnosti 3 i dozvoli da ponovo radi test.
                </Tooltip>}
              >
                <button className="btn btn-info btn-fill" onClick={this.intIII.bind(this, intern._id, intern.name)} />
              </OverlayTrigger>
              {intern.intIII}
            </td>
            <td>
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>
                  Pokaži grafik testa ličnosti.
                </Tooltip>}
              >
                <div className="col-md-2">
                  <Link
                    to={`/adminPanel/adminGraph/${intern._id}`}
                    className="btn btn-info btn-fill"
                    style={{ margin: '3px' }}
                  />
                </div>
              </OverlayTrigger>
            </td>
          </tr >
        ))
      } else {
        tableData = (
          <tr>
            <td>Nemam nista za prikazati</td>
          </tr>
        )
      }
    }
    let helloMessage = this.props.auth.user.name === "Jana Vujić" ? (<span> Ćao Jano </span>) : (<span> Ćao Sofija </span>)

    return (
      <div className="Content">
        <div style={div1}>
          <div style={div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <div className='d-flex justify-content-between"'>
                  <div className='col-md-4'>
                    <div style={centerText}>
                      Dodavanje novog kandidata<br /><br />
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <TextFieldGroup
                          placeholder="Ime i prezime"
                          name="name"
                          value={this.state.name}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-5">
                        <TextFieldGroup
                          placeholder="email "
                          name="email"
                          value={this.state.email}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-info btn-fill"
                          onClick={this.addNewIntern.bind(this)}
                        >Unesi</button>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div style={centerText}>
                      Izvoz svih rezultata<br /><br />
                    </div>
                    <div className="row">
                      <div className="col-md-5" />
                      <div className="col-md-3">
                        <button
                          className="btn btn-success btn-fill"
                          onClick={this.getResultsAll.bind(this)}
                        >Izvoz</button>
                      </div>
                      <div className="col-md-4" />
                    </div>
                  </div>
                  <div className='col-md-1'>
                    <div className='row'>
                      <button
                        className="btn btn-info btn-fill"
                        onClick={this.getInternsByStatus.bind(this, 'active')}
                      >Aktivni</button>
                    </div>
                    <div className='row' style={{ marginTop: '10px' }}>
                      <button
                        className="btn btn-info btn-fill"
                        onClick={this.getInternsByStatus.bind(this, 'hidden')}
                      >Skriveni</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div style={div1}>
          <div style={div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <br /><br />
                <div style={centerText}>{helloMessage}</div>
                <br />
                <Table striped bordered hover variant="grey">
                  <thead>
                    <tr>
                      <td>Ime</td>
                      <td>Mail</td>
                      {/*<td>Engleski</td>*/}
                      <td>Ličnost</td>
                      {/*<td>Excel preuzet</td>*/}
                      <td>Int I</td>
                      <td>Int II</td>
                      <td>Int III</td>
                      <td>Grafik</td>
                    </tr>
                  </thead>
                  <tbody>{tableData}</tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
)(adminPanel);